export default "__VITE_ASSET__76c944a6__"